exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "main[data-v-8c6ec5be]{min-height:50vh}", ""]);

